/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Today_Hero_EyebrowInputs */

const en_us2_today_hero_eyebrow = /** @type {(inputs: Today_Hero_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Today · Workout ${i?.label}`)
};

const pt_br2_today_hero_eyebrow = /** @type {(inputs: Today_Hero_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoje · Treino ${i?.label}`)
};

const es_419_today_hero_eyebrow = /** @type {(inputs: Today_Hero_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoy · Entrenamiento ${i?.label}`)
};

const pt_pt2_today_hero_eyebrow = /** @type {(inputs: Today_Hero_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoje · Treino ${i?.label}`)
};

const fr_fr2_today_hero_eyebrow = /** @type {(inputs: Today_Hero_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aujourd'hui · Séance ${i?.label}`)
};

const de_de2_today_hero_eyebrow = /** @type {(inputs: Today_Hero_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Heute · Training ${i?.label}`)
};

const it_it2_today_hero_eyebrow = /** @type {(inputs: Today_Hero_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oggi · Allenamento ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Today · Workout {label}" |
*
* @param {Today_Hero_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_hero_eyebrow = /** @type {((inputs: Today_Hero_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Hero_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_hero_eyebrow(inputs)
	if (locale === "es-419") return es_419_today_hero_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_today_hero_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_today_hero_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_today_hero_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_today_hero_eyebrow(inputs)
	return en_us2_today_hero_eyebrow(inputs)
});
export { today_hero_eyebrow as "today.hero_eyebrow" }